import { css } from 'styled-components';

export const StyledRteHtmlTextNoFont = css`
  // Stili per il testo generato dell'editor RichTextInput
  margin-block-start: 0;
  margin-block-end: 0;
  margin-bottom: 0;
  margin-top: 0;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-block-start: 0;
    margin-block-end: 0;
    margin-top: 0;
    margin-bottom: ${props => props.theme.rteHtmlTagMarginBottom}em;
    font-weight: 500;
  }

  p,
  a,
  ol,
  ul,
  dl {
    margin-block-start: 0;
    margin-block-end: 0;
    margin-top: 0;
    margin-bottom: ${props => props.theme.rteHtmlTagMarginBottom}em;

    p {
      margin-bottom: 0;
    }
  }
  a {
    text-decoration: underline;
    color: ${props => props.theme.rteLinkColor};
    &:hover,
    &:focus,
    &:focus-visible {
      color: ${props => props.theme.rteLinkHoverColor};
    }
    &:active {
      color: ${props => props.theme.rteLinkHoverColor};
    }
  }

  ol ol,
  ul ul,
  ol ul,
  ul ol {
    margin-block-start: 0;
    margin-block-end: 0;
    margin-bottom: 0;
  }

  b,
  strong {
    font-weight: 700;
  }
  pre {
    margin-block-start: 0;
    margin-block-end: 0;
    margin-top: 0;
    margin-bottom: ${props => props.theme.rteHtmlTagMarginBottom}em;
    overflow: auto;
  }
`;
